<form [formGroup]="formGroup">
    <lsq-input
        *ngIf="!reviewMode"
        ngDefaultControl
        [(ngModel)]="field.fieldValue"
        [name]="fieldSchema.name"
        [label]="this.addRequiredAsterisk(fieldSchema)"
        [popover]="fieldSchema.tooltip"
        [popoverDisabled]="!fieldSchema.tooltip"
        [group]="formGroup"
        [formControlName]="fieldSchema.name"
        [type]="
            fieldSchema.fieldOption?.inputType
                ? transformType(fieldSchema.fieldOption?.inputType)
                : null
        "
        [disabled]="isReadOnly()"
        [usesNgxMask]="true"
        [mask]="this.getMask()"
    >
    </lsq-input>
</form>
